// extracted by mini-css-extract-plugin
export default {"contact":"contactStyles_contact__LF8cS"};